import { Card, Typography } from "@mui/material";
import { formatNumber } from "src/utils/formatNumberHelper";

interface AppWidgetSummaryProps {
	color?: string;
	icon?: string;
	title: string;
	total: number;
	sx?: any;
	format?: string;
}

export default function AppWidgetSummary({
	title,
	total,
	icon,
	color = "primary",
	sx,
	format = "number",
	...other
}: AppWidgetSummaryProps) {
	return (
		<Card
			sx={{
				py: 2,
				px: 2,
				boxShadow: 0,
				textAlign: "center",
				color: (theme: any) => theme.palette[color].darker,
				bgcolor: (theme: any) => theme.palette[color].lighter,
				...sx,
			}}
			{...other}
		>
			<Typography variant="h5">{formatNumber(total, format)}</Typography>

			<Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
				{title}
			</Typography>
		</Card>
	);
}
